<template>
  <div class="home">
    <swiper
        v-if="!isMobile"
        id="swiperBox"
        :options="swiperOption"
        ref="mySwiper"
        class="swiper-container"
    >
      <swiper-slide class="swiper-slide slide-one" :style="{backgroundImage: `url(${shouyeBanner})`}">
        <div class="page">
          <h3>特格尔集团</h3>
          <p></p>
        </div>
        <p class="slogan">特格尔 爱的智慧</p>
      </swiper-slide>

      <swiper-slide class="swiper-slide slide-three" v-loading="loading">
        <div class="page">
          <h3>热门资讯</h3>
          <p>Latest News</p>
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(news,i) in newsList" :key="i">
            <div class="item-img-wrapper" :class="i%2==0 ? 'order-normal' : 'order-reverse'">
              <router-link
                  class="text-decoration"
                  :to="{ name: 'newsdetails', params: { id: news.informationId }}"
              >
                <div class="item-img" v-lazy:background-image="getImageUrl(news)"></div>
              </router-link>
            </div>
            <div class="item-divider" style="order: 2">
              <el-divider>
                <i class="el-icon-apple"></i>
              </el-divider>
            </div>
            <div class="item-content" :class="i%2==0 ? 'order-reverse' : 'order-normal'">
              <h3>{{news.informationTitle}}</h3>
              <p>{{news.informationSummary || news.informationTitle}}</p>
              <span>{{news.releaseTime}}</span>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <!-- =========手机端：不使用swiper，原生两块div========= -->
    <div v-if="isMobile" class="mobile-wrap">
      <div class="slide-one" :style="{backgroundImage: `url(${shouyeBanner})`}">
        <div class="page">
          <h3>特格尔集团</h3>
          <p></p>
        </div>
        <p class="slogan">特格尔 爱的智慧</p>
      </div>
      <div class="slide-three" v-loading="loading">
        <div class="page">
          <h3>热门资讯</h3>
          <p>Latest News</p>
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(news,i) in newsList" :key="i">
            <div class="item-img-wrapper">
              <router-link
                  class="text-decoration"
                  :to="{ name: 'newsdetails', params: { id: news.informationId }}"
              >
                <div class="item-img" v-lazy:background-image="getImageUrl(news)"></div>
              </router-link>
            </div>
            <div class="item-content">
              <h3>{{news.informationTitle}}</h3>
              <p>{{news.informationSummary || news.informationTitle}}</p>
              <span>{{news.releaseTime}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      isMobile: false,
      shouyeBanner: "",
      loading: true,
      newsList: [],
      swiperOption: {
        notNextTick: true,
        direction: "vertical",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: false,
        slidesPerView: 1,
        mousewheel: true,
        resistanceRatio: 0,
        observer: true,
        observeParents: true,
        on: {
          resize: function () {
            this.update();
          }
        }
      }
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.getHotNews();
    this.shouyeBanner = this.$appData.shouyeBanner || "https://lilishop.oss-cn-beijing.aliyuncs.com/tgrhome.jpg";
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile(){
      // 768作为断点，小于等于768判定手机端
      this.isMobile = window.innerWidth <= 768
    },
    getImageUrl(news) {
      if (news.informationCoverList && news.informationCoverList.length > 0) {
        return news.informationCoverList[0];
      }
      return '';
    },
    getHotNews() {
      let formData = {
        page: 1,
        limit: 3,
        classifyId: 3,
      }
      this.$http
          .post(`https://www.tgr39.com/mall-base/baseInformationInfo/userQueryInformationInfoById`, formData)
          .then(response => {
            let resData = response.data.data;
            this.newsList = resData.list || [];
            this.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            this.loading = false;
          });
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
}
.swiper-container {
  width: 100%;
  height: calc(100vh - 60px);
}

/* ========== PC swiper【完全原样，没有任何改动】 ========== */
.swiper-slide {
  font-size: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;
    h3, p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }
  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}

.slide-one {
}
.slide-three {
  background: url(https://lilishop.oss-cn-beijing.aliyuncs.com/tgrhome_anli.jpg) no-repeat center;
  background-size: cover;
}

.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }
    .item-divider {
      .el-divider {
        background-color: #fff;
        height: 3px;
        .el-divider__text {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          padding: 0px;
          color: #fff;
        }
      }
    }
    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }
      h3, p, span {
        color: #fff;
      }
    }
  }
}
.order-normal { order: 1; }
.order-reverse { order: 3; }

/* =========只改这里：手机端，压缩新闻间距，消除大片空白========= */
.mobile-wrap{
  width:100%;
}
.mobile-wrap .slide-one{
  width:100%;
  min-height: calc(100vh - 50px);
  display:flex;
  flex-direction:column;
  justify-content:center;
  background-size: cover;
  background-position:center;
  .page{
    text-align:center;
    h3{font-size:28px;color:#fff;}
    p{font-size:16px;color:#fff;}
  }
  .slogan{
    text-align:center;
    font-size:30px;
    color:#fff;
    padding:20px 0;
  }
}
.mobile-wrap .slide-three{
  width:100%;
  min-height:auto;
  background: url(https://lilishop.oss-cn-beijing.aliyuncs.com/tgrhome_anli.jpg) no-repeat center;
  background-size: cover;
  padding-top: 20px;

  .page{
    text-align:center;
    margin-bottom:16px;
    h3{font-size:28px;color:#fff;}
    p{font-size:16px;color:#fff;}
  }
}
.mobile-wrap .news-content{
  width:100%;
  padding:0 15px;
  box-sizing:border-box;
  &-item{
    width:100%;
    margin-bottom: 20px; /* 缩小新闻块之间的间隔 */
    display:flex;
    flex-direction:column;
    .item-img{
      width:100%;
      height:170px;
      border-radius:6px;
      background-size:cover;
      background-position:center;
    }
    .item-content{
      padding-top:8px;
      h3{
        font-size:17px;
        color:#fff;
        line-height:1.4;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-line-clamp:2;
        -webkit-box-orient:vertical;
        margin:0;
      }
      p{
        font-size:13px;
        color:#fff;
        margin:4px 0;
        display:-webkit-box;
        -webkit-line-clamp:2;
        -webkit-box-orient:vertical;
        overflow:hidden;
      }
      span{
        font-size:12px;
        color:#fff;
        text-align:right;
        opacity:0.85;
        display:block;
        margin-top:2px;
      }
    }
  }
}

@media screen and (min-width:769px) {
  .mobile-wrap{
    display:none !important;
  }
}
@media screen and (max-width:768px) {
  .swiper-container{
    display:none !important;
  }
}
</style>